import CategoryToolbar from "./components/CategoryToolbar";
import CategoryGrid from "./components/CategoryGrid";
import OptionGrid from "./components/OptionGrid";
import CategoryDrawer from "./components/CategoryDrawer";

import { CategoryProvider } from "./context/CategoryContext";
import { useCategoryTabStore } from "./store/CategoryTabStore";
import OptionDrawer from "./components/OptionDrawer";

export default function CategoriesTab() {
    const { isShowOptions } = useCategoryTabStore();

    return (
        <CategoryProvider>
            <CategoryToolbar />

            {
                !isShowOptions ?
                    <CategoryGrid /> :
                    <OptionGrid />
            }

            <CategoryDrawer />
            <OptionDrawer />
        </CategoryProvider>
    );
}
